export default {
  handler: 'relativeUrl',
  data: ({ mobileSlug }) => `/pages/${mobileSlug}`,
};
